const PROVIDER_IDS = Object.freeze({
    PRIMARY_PROVIDER: 'canwise-insurance-services',
    POLICY_ME: 'policyme',
});

export default PROVIDER_IDS;
